import { BaseService, Service } from "/@/cool";

@Service("customizedOrderStatusForShop")
class CustomizedOrderStatusForShop extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		// this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["page"] = prefix + "page";
		this.permission["batchUpdate"] = prefix + "batchUpdate";
		this.permission["page"] = prefix + "page";
	}

	page(data: any) {
		return this.request({
			url: "/page",
			method: "POST",
			data
		});
	}

	update(data: any) {
		return this.request({
			url: "/update",
			method: "POST",
			data
		});
	}

	batchUpdate(data: any) {
		return this.request({
			url: "/batchUpdate",
			method: "POST",
			data
		});
	}
}

export default CustomizedOrderStatusForShop;
